import { GeneralSettingsActions, GeneralSettingsActionTypes } from './general-settings-actions'
import { GeneralSettingsState, initialGeneralSettingsState } from './general-settings-state'

export function generalSettingsReducer(previousState: GeneralSettingsState | undefined, action: GeneralSettingsActions): GeneralSettingsState {
    const state = previousState || initialGeneralSettingsState
    switch (action.type) {
        case GeneralSettingsActionTypes.SET_ORGANIZATION_SETTINGS:
            return { ...state, organizationMetadata: action.payload.organizationMetadata }
        case GeneralSettingsActionTypes.SET_ORGANIZATION_SETTINGS_LOADING:
            return { ...state, loading: action.payload.loading }
        case GeneralSettingsActionTypes.UPDATE_ORGANIZATION_SETTINGS_SUCCESS:
            return { ...state, organizationMetadata: action.payload.organizationMetadata }
        case GeneralSettingsActionTypes.SET_ORGANIZATION_SETTINGS_SAVING:
            return { ...state, saving: action.payload.saving }
        default: {
            return state
        }
    }
}
